const createCustomerMapMarker = ({
    OverlayView = google.maps.OverlayView,
    ...args
}) => {

    class CustomerMapMarker extends OverlayView {
        constructor() {
            super();
            this.latlng = args.latlng;
            this.html = args.html;
            this.setMap(args.map);

            this.divWidth = "16px";
            this.divHeight = "16px";
            this.color = args.color;
            this.click = args.click;
        }


        createDiv() {
            this.div = document.createElement("div");
            this.div.style.position = "absolute";
            this.div.style.width = this.divWidth;
            this.div.style.height = this.divHeight;
            this.div.style.backgroundColor = this.color;
            // this.div.style.borderRadius = "6px";
            this.div.style.paddingTop = "1px";
            this.div.style.border = "1px solid black";
            this.div.style.borderRadius = "12px";

            this.div.style.webkitTransform = 'translateZ(0px)';
            this.div.style.zIndex = 4;

            var me = this;
            var click = this.click;

            google.maps.event.addDomListener(this.div, "click", event => {
                click();
                google.maps.event.trigger(me, "click");
            });
        }

        appendDivToOverlay() {
            this.getPanes().overlayMouseTarget.appendChild(this.div);
        }

        positionDiv() {
            const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
            if (point) {
                this.div.style.left = `${point.x - 8}px`;
                this.div.style.top = `${point.y - 8}px`;
            }
        }

        draw() {

            if (!this.div) {
                this.createDiv();
                this.appendDivToOverlay();
            }
            this.positionDiv();
        }

        remove() {

            this.setMap(null);

            if (this.div) {
                this.div.parentNode.removeChild(this.div);
                this.div = null;
            }
        }

        getPosition() {
            return this.latlng;
        }

        getDraggable() {
            return false;
        }
    }

    return new CustomerMapMarker();

}

export default createCustomerMapMarker;